<template>
  <v-slide-x-reverse-transition>
    <v-card raised class="elevation-5 rule-quick-view vop-bg-whisper" v-if="isVisible">
      <div>
        <!-- Toolbar -->
        <v-toolbar flat class="vop-bg-whisper">
          <!-- Title -->
          <v-toolbar-title class="subheading ttu font-weight-medium">
            <span>{{ messages.label.RULE }} - {{ selectedRule.title }}</span>
          </v-toolbar-title>
          <v-spacer></v-spacer>
          <!-- Test button -->
          <v-btn color="secondary" @click="showTestRuleModal()" small>
            {{ messages.label.TEST }}
          </v-btn>
          <!-- More Menu -->
          <v-menu offset-y left v-show="!inDialog">
            <template v-slot:activator="{ on }">
              <v-btn class="grey--text text--darken-2" v-on="on" small>
                {{ messages.label.ACTIONS }}
              </v-btn>
            </template>
            <v-list>
              <v-list-tile @click="goToEditView()">
                <v-list-tile-title>{{
                messages.label.EDIT
                }}</v-list-tile-title>
              </v-list-tile>
              <v-list-tile class="error--text" @click="showDeleteDialog()">
                <v-list-tile-title>{{
                messages.label.DELETE
                }}</v-list-tile-title>
              </v-list-tile>
            </v-list>
          </v-menu>
          <v-toolbar-items>
            <!-- Close button -->
            <v-btn icon medium @click="hide()">
              <v-icon>mdi-window-close</v-icon>
            </v-btn>
          </v-toolbar-items>
        </v-toolbar>
        <!-- Main Content -->
        <v-card-text>
          <!-- Error Alert -->
          <v-flex xs12 v-if="errorAlert">
            <v-alert v-model="errorAlert" dismissible type="error">
              {{ errorMessage }}
            </v-alert>
          </v-flex>
          <v-tabs v-model="activeTab" color="vop-bg-whisper" slider-color="primary">
            <v-tab v-for="item in tabItems" :key="item.id" :class="{ 'd-none': !item.visible }">
              {{ item.title }}
            </v-tab>
          </v-tabs>
          <v-layout wrap>
            <v-flex xs12>
              <v-tabs-items v-model="activeTab">
                <!-- Rule Details -->
                <v-tab-item>
                  <v-data-table :items="ruleDetails" hide-actions hide-headers class="mt-2">
                    <template slot="items" slot-scope="props">
                      <tr>
                        <td class="text-xs-left ttu" width="30%">
                          {{ props.item.name }}
                        </td>
                        <td class="text-xs-left">
                          <!-- Inline Title Edit -->
                          <template v-if="props.item.name === 'title'">
                            <div v-if="inDialog">
                              {{ props.item.value }}
                            </div>
                            <div v-else>
                              <v-edit-dialog :return-value.sync="props.item.value" large lazy persistent
                                @save="saveField(props.item.value, 'title')" @cancel="cancelInlineEdit">
                                <!-- Title Display -->
                                <div v-if="!$lodash.isEmpty(props.item.value)">
                                  {{ props.item.value }}
                                  <v-icon small class="ml-2" color="primary">mdi-circle-edit-outline</v-icon>
                                </div>
                                <div v-else>
                                  {{ messages.label.ADD_TITLE }}
                                  <v-icon small class="ml-2" color="primary">add_circle</v-icon>
                                </div>
                                <!-- Title Edit Input -->
                                <template v-slot:input>
                                  <div class="mt-3 subtitle ttu" v-if="!$lodash.isEmpty(props.item.value)">
                                    {{ messages.label.UPDATE_TITLE }}
                                  </div>
                                  <div class="mt-3 subtitle ttu" v-else>
                                    {{ messages.label.ADD_TITLE }}
                                  </div>
                                  <v-text-field v-model="props.item.value" clearable
                                    v-validate="{ required: true, max:100, regex: /^[0-9a-zA-Z\s\/_-]*$/i }"
                                    :error-messages="errors.collect('title')" data-vv-name="title" :counter="100"
                                    :label="messages.label.RULE_TITLE" single-line autofocus>
                                  </v-text-field>
                                </template>
                              </v-edit-dialog>
                            </div>
                          </template>
                          <!-- Inline Description Edit -->
                          <template v-else-if="props.item.name === 'description'">
                            <div v-if="inDialog">
                              {{ props.item.value | displayNA }}
                            </div>
                            <div v-else>
                              <v-edit-dialog :return-value.sync="props.item.value" large lazy persistent @save="
                                saveField(props.item.value, 'description')
                              " @cancel="cancelInlineEdit">
                                <!-- Description Display -->
                                <div v-if="
                                  !$lodash.isEmpty(props.item.value) &&
                                  !$lodash.isNull(props.item.value)
                                ">
                                  {{ props.item.value }}
                                  <v-icon small class="ml-2" color="primary">mdi-circle-edit-outline</v-icon>
                                </div>
                                <div v-else>
                                  {{ messages.label.ADD_DESCRIPTION }}
                                  <v-icon small class="ml-2" color="primary">add_circle</v-icon>
                                </div>
                                <!-- Description Edit Input -->
                                <template v-slot:input>
                                  <div class="mt-3 subtitle ttu" v-if="!$lodash.isEmpty(props.item.value)">
                                    {{ messages.label.UPDATE_DESCRIPTION }}
                                  </div>
                                  <div class="mt-3 subtitle ttu" v-else>
                                    {{ messages.label.ADD_DESCRIPTION }}
                                  </div>
                                  <v-textarea v-model="props.item.value" clearable v-validate="'max:500'"
                                    :error-messages="
                                      errors.collect('description')
                                    " data-vv-name="description" :counter="500"
                                    :label="messages.label.RULE_DESCRIPTION" single-line autofocus>
                                  </v-textarea>
                                </template>
                              </v-edit-dialog>
                            </div>
                          </template>
                          <!-- Inline Enabled status edit -->
                          <template v-else-if="props.item.name === 'enabled'">
                            <div v-if="inDialog">
                              {{ props.item.value }}
                            </div>
                            <div v-else>
                              <v-edit-dialog :return-value.sync="props.item.value" large lazy persistent
                                @save="saveField(props.item.value, 'enabled')" @cancel="cancelInlineEdit">
                                <!-- Enabled Status Display -->
                                {{ props.item.value }}
                                <v-icon small class="ml-2" color="primary">mdi-circle-edit-outline</v-icon>
                                <!-- Description Edit Input -->
                                <template v-slot:input>
                                  <div class="mt-3 subtitle ttu">
                                    {{ messages.label.UPDATE_ENABLED }}
                                  </div>
                                  <v-switch v-model="props.item.value" class="mt-0" hide-details color="primary"
                                    :label="`${props.item.value.toString()}`">
                                  </v-switch>
                                </template>
                              </v-edit-dialog>
                            </div>
                          </template>
                          <template v-else-if="props.item.name === 'updated'">
                            {{ props.item.value ? props.item.value : "---" }}
                            {{getUserIdString('updatedByUserId')}}
                          </template>
                          <template v-else-if="props.item.name === 'added'">
                            {{ props.item.value }} {{getUserIdString('addedByUserId')}}
                          </template>
                          <template v-else>
                            <div>
                              {{ props.item.value }}
                            </div>
                          </template>
                        </td>
                      </tr>
                    </template>
                  </v-data-table>
                </v-tab-item>
                <!-- Conditions -->
                <v-tab-item>
                  <v-data-table :headers="ruleConditionsHeaders" :items="ruleConditions" class="mt-1">
                    <template slot="items" slot-scope="props">
                      <td class="text-xs-left" width="5%">
                        <v-btn flat icon small color="secondary" @click="props.expanded = !props.expanded">
                          <v-icon>{{
                          props.expanded ? "remove_circle" : "add_circle"
                          }}</v-icon>
                        </v-btn>
                      </td>
                      <td class="text-xs-left" widht="40%">
                        {{ props.item.title }}
                      </td>
                      <td class="text-xs-left">
                        {{ props.item.conditionType }}
                      </td>
                      <td class="text-xs-left">{{ props.item._fieldName }}</td>
                      <td class="text-xs-left">{{ props.item.severity }}</td>
                      <td class="text-xs-left">{{ props.item.negate }}</td>
                    </template>
                    <!-- Expanded view-->
                    <template slot="expand" slot-scope="props">
                      <ConditionQuickView :condition="props.item" class="indigo lighten-5" />
                    </template>
                    <!-- No Data -->
                    <template slot="no-data">
                      <v-alert :value="true" color="info" class="black--text" icon="info">
                        {{ messages.info.NO_RULE_CONDITION }}
                      </v-alert>
                    </template>
                  </v-data-table>
                </v-tab-item>
                <!-- Actions -->
                <v-tab-item :class="{
                  'd-none': selectedRule.type !== 'TRANSFORMATION'
                }">
                  <v-data-table :headers="ruleActionsHeaders" :items="ruleActions" class="mt-1" ref="draggableTable">
                    <template slot="items" slot-scope="props">
                      <td class="handle" style="max-width: 28px">
                        <v-icon>drag_handle</v-icon>
                      </td>
                      <td class="text-xs-center">
                        {{ props.item.sequence + 1 }}
                      </td>
                      <td class="text-xs-left" widht="40%">
                        {{ props.item.title }}
                      </td>
                      <td class="text-xs-left">{{ props.item.actionType }}</td>
                      <td class="text-xs-left">{{ props.item._fieldName }}</td>
                    </template>
                    <!-- No Data -->
                    <template slot="no-data">
                      <v-alert :value="true" color="info" class="black--text" icon="info">
                        {{ messages.info.NO_ACTIONS }}
                      </v-alert>
                    </template>
                  </v-data-table>
                  <v-btn color="primary" v-if="displayUpdateActionsButton" :disabled="updateActionsInProgress"
                    :loading="updateActionsInProgress" @click="updateActionsSequence()">
                    {{ messages.label.SAVE }}
                  </v-btn>
                </v-tab-item>
                <!-- JSON View -->
                <v-tab-item>
                  <JSONView :json="selectedRuleJSON" />
                </v-tab-item>
              </v-tabs-items>
            </v-flex>
          </v-layout>
        </v-card-text>
      </div>
      <v-card-actions class="px-3">
        <v-spacer />
        <v-flex v-if="inDialog" class="text-lg-right">
          <v-btn color="primary" @click="hide()">
            {{ messages.label.OK }}
          </v-btn>
        </v-flex>
      </v-card-actions>
      <!-- Rule Test Dialog -->
      <XVATRuleTest v-model="ruleTestDialog" :rule-obj="ruleObjectToTest" :rule-category="'rule'" />
      <!-- Rule Copy Dialog -->
      <XVATRuleCopy v-model="ruleCopyDialog" :rule-obj="ruleObjectToCopy" />
      <!-- Rule Override Dialog -->
      <XVATRuleOverride v-model="ruleOverrideDialog" :rule-obj="ruleObjectToOverride" />
      <!-- Snackbar -->
      <v-flex xs12>
        <v-snackbar :bottom="true" :timeout="snackbar.timeout" :color="snackbar.color" v-model="snackbar.show">
          {{ snackbar.message }}
          <v-btn flat color="primary" @click.native="snackbar.show = false">Ok</v-btn>
        </v-snackbar>
      </v-flex>
      <!-- Delete Dialog -->
      <v-dialog v-model="deleteDialog" width="500">
        <v-card>
          <v-card-title class="subheading ttu">
            {{ messages.label.DELETE }}
          </v-card-title>
          <v-card-text>
            <!-- Error Alert -->
            <v-flex xs12 v-if="deleteErrorAlert">
              <v-alert v-model="deleteErrorAlert" type="error">
                {{ deleteErrorMessage }}
              </v-alert>
            </v-flex>
            <v-flex xs12 v-else>
              <p>
                {{ messages.info.DELETE_RULE_1 }}
                <b>{{ selectedRule.title }}</b> ?
              </p>
              <p v-html="messages.info.DELETE_RULE_2"></p>
            </v-flex>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <template v-if="deleteErrorAlert">
              <v-btn color="secondary lighten-1 white--text" @click="cancelDelete">Close</v-btn>
            </template>
            <template v-else>
              <v-btn color="grey lighten-1 white--text" @click="cancelDelete">
                {{ messages.label.CANCEL }}
              </v-btn>
              <v-btn color="error" :disabled="deletingRule" :loading="deletingRule" @click="deleteRule()">
                {{ messages.label.YES }}
              </v-btn>
            </template>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-card>
  </v-slide-x-reverse-transition>
</template>

<script>
import { mapState, mapActions } from "vuex"
// import ace from "brace"
import "brace/mode/javascript"
import "brace/theme/eclipse"
import "brace/ext/searchbox"
import Sortable from "sortablejs"
import XVATRulesService from "@/XVAT/XVATRulesService"
import * as xvatDataService from "@/XVAT/XVATDataService"
import ConditionQuickView from "@/XVAT/Rule/ConditionQuickView"
import JSONView from "@/XVAT/JSONView"
import XVATRuleTest from "@/XVAT/XVATRuleTest"
import messages from "@/XVAT/messages.json"
import { GET_XPATH_MAPPINGS_LIST } from "@/store/constants/action-types"
import {
  RULE_TYPE_VALIDATION,
  RULE_TYPE_TRANSFORMATION
} from "../constants"
import XVATRuleCopy from "@/XVAT/XVATRuleCopy"
import XVATRuleOverride from "@/XVAT/XVATRuleOverride"

export default {
  name: "RuleQuickView",
  components: {
    ConditionQuickView,
    JSONView,
    XVATRuleTest,
    XVATRuleCopy,
    XVATRuleOverride
  },
  $_veeValidate: {
    validator: "new"
  },
  data() {
    return {
      snackbar: {
        show: false,
        timeout: 3000,
        color: "error",
        message: ""
      },
      errorAlert: false,
      errorMessage: "",
      ruleObjectToTest: {},
      ruleObjectToCopy: {},
      ruleObjectToOverride: {},
      ruleTestDialog: false,
      ruleCopyDialog: false,
      ruleOverrideDialog: false,
      activeTab: null,
      selectedRule: {},
      selectedRuleJSON: {},
      selectedRuleOriginal: {},
      isVisible: false,
      ruleDetails: [],
      ruleConditionsHeaders: this.getRuleConditionsHeaders(),
      ruleConditions: [],
      ruleActionsHeaders: this.getRuleActionsHeaders(),
      ruleActions: [],
      dictionary: this.getValidationDictionary(),
      inDialog: false,
      deleteDialog: false,
      deletingRule: false,
      deleteErrorAlert: false,
      deleteErrorMessage: "",
      updateActionsInProgress: false,
      tabItems: this.getTabItems(),
      actionJS: ""
    }
  },
  mounted() {
    // Validator initialization
    this.$validator.localize("en", this.dictionary)
  },
  computed: {
    ...mapState("xvat", ["xpathMappingsList"]),
    displayUpdateActionsButton() {
      let display = false
      let currentActionsArrayOfStrings = XVATRulesService.stringifyArrayOfObjects(
        this.ruleActions
      )
      let originalActionsArrayOfStrings = XVATRulesService.stringifyArrayOfObjects(
        this.selectedRuleOriginal.actions
      )
      if (JSON.stringify(currentActionsArrayOfStrings) !== JSON.stringify(originalActionsArrayOfStrings)) {
        display = true
      }

      return display
    },
    editorHeight() {
      let height = 50
      switch (this.$vuetify.breakpoint.name) {
        case "xs":
          height = 55
          break
        case "sm":
          height = 55
          break
        case "md":
          height = 60
          break
        case "lg":
          height = 60
          break
        case "xl":
          height = 65
          break
      }
      // if (this.errorAlert) {
      //   height = height - 8
      // }
      return `${height}vh`
    }
  },
  methods: {
    ...mapActions("xvat", [GET_XPATH_MAPPINGS_LIST]),

    /**
     * show - Shows rule details quick view
     * @param {object} selectedRule
     */
    show(selectedRule) {
      this.resetData()
      this.selectedRule = selectedRule
      this.updateTabsVisibility()
      this.selectedRuleJSON = {}
      this.selectedRuleOriginal = this.$lodash.cloneDeep(this.selectedRule)
      this.constructRuleDetails()
      this.parseConditions()
      this.parseActions()
      this.$nextTick(() => {
        // NOTE: using 'nextTick' as the json view doesn't seem load the first time
        this.constructJSONViewObject()
      })
      // TODO : Ideally we would want to leave tab selection as is when the user is switching
      // between rows, due to the tab update issues, we are defaulting to showing first tab
      this.isVisible = true
      this.activeTab = 0
    },

    /**
     * showInDialog - Show quick view dialog
     * @param {object} selectedRule
     */
    showInDialog(selectedRule) {
      this.inDialog = true
      this.show(selectedRule)
    },

    /**
     * resetData - Reset data
     */
    resetData() {
      this.errorAlert = false
      this.errorMessage = ""
    },

    /**
     * Tab items list
     */
    getTabItems() {
      return [
        { id: 1, title: "DETAILS", visible: true },
        { id: 2, title: "CONDITIONS", visible: true },
        { id: 3, title: "ACTIONS", visible: false },
        { id: 4, title: "{ JSON }", visible: true }
      ]
    },

    /**
     * Update tab visibility
     * NOTE:  We need to do this lengthy logic as dynamic tabs doesn't work correct in current version of Vuetify (1.5)
     */
    updateTabsVisibility() {
      const currentType = this.selectedRule.type

      if (currentType === RULE_TYPE_TRANSFORMATION) {
        this.tabItems[2].visible = true // Actions
      } else if (currentType === RULE_TYPE_VALIDATION) {
        this.tabItems[2].visible = false // Actions
      }
    },

    /**
     * Enables drag and drop for actions
     */
    enableActionsDragDrop() {
      this.$nextTick(() => {
        let table = this.$refs.draggableTable.$el.getElementsByTagName(
          "tbody"
        )[0]
        const _self = this
        Sortable.create(table, {
          handle: ".handle", // Use handle so user can select text
          onEnd({ newIndex, oldIndex }) {
            const rowSelected = _self.ruleActions.splice(oldIndex, 1)[0] // Get the selected row and remove it
            _self.ruleActions.splice(newIndex, 0, rowSelected) // Move it to the new index
            _self.resetActionSequenceNumbers()
          }
        })
      })
    },

    /**
     * retrieveXPathMappings - Retreive mappings to display field dropdown
     */
    retrieveXPathMappings() {
      if (this.xpathMappingsList.length === 0) {
        return this.GET_XPATH_MAPPINGS_LIST()
      } else {
        return Promise.resolve(this.xpathMappingsList)
      }
    },

    /**
     * getValidationDictionary - Validation messages for vee-validate
     * @returns {object}
     */
    getValidationDictionary() {
      return {
        custom: {
          title: {
            required: () => "Title can't be empty",
            max: "Title may not be greater than 100 characters",
            regex: "Valid characters are : A-Z a-z 0-9 / _ -"
          },
          description: {
            max: "Description may not be greater than 100 characters"
          }
        }
      }
    },

    /**
     * getRuleConditionsHeaders - Construct array of objects to show table headers
     * @return {array}
     */
    getRuleConditionsHeaders() {
      let headers = [
        {
          text: "",
          sortable: false
        },
        {
          text: messages.label.TH_TITLE,
          sortable: false,
          align: "left",
          value: "title"
        },
        {
          text: messages.label.TH_TYPE,
          sortable: false,
          align: "left",
          value: "type"
        },
        {
          text: messages.label.TH_FIELD,
          sortable: false,
          align: "left",
          value: "_fieldName"
        },
        {
          text: messages.label.TH_SEVERITY,
          sortable: false,
          align: "left",
          value: "severity"
        },
        {
          text: messages.label.TH_NEGATE,
          sortable: false,
          align: "left",
          value: "negate"
        }
      ]
      return headers
    },

    /**
     * getRuleActionsHeaders - Construct array of objects to show table headers
     * @return {array}
     */
    getRuleActionsHeaders() {
      let headers = [
        {
          text: "",
          sortable: false
        },
        {
          text: "SEQUENCE",
          align: "center",
          value: "sequence",
          sortable: false
        },
        {
          text: messages.label.TH_TITLE,
          sortable: false,
          align: "left",
          value: "title"
        },
        {
          text: messages.label.TH_TYPE,
          sortable: false,
          align: "left",
          value: "actionType"
        },
        {
          text: messages.label.TH_FIELD,
          sortable: false,
          align: "left",
          value: "_fieldName"
        }
      ]
      return headers
    },

    /**
     * Reset / update sequence numbers for rule actions
     */
    resetActionSequenceNumbers() {
      if (this.ruleActions.length > 0) {
        this.$lodash.forEach(this.ruleActions, (action, index) => {
          action["sequence"] = index
        })
      }
    },

    /**
     * constructRuleDetails - Construct selected rule details
     * This is being done to display in a data table
     */
    constructRuleDetails() {
      this.ruleDetails = []
      let requiredFields = [
        "title",
        "type",
        "description",
        "_enabled",
        "_added",
        "_updated"
      ]
      requiredFields.forEach(fieldName => {
        let obj = {}
        if (this.selectedRule.hasOwnProperty(fieldName)) {
          obj["name"] =
            fieldName.charAt(0) === "_" ? fieldName.substring(1) : fieldName

          if (fieldName === "description") {
            obj["value"] = decodeURI(this.selectedRule[fieldName])
          } else {
            obj["value"] = this.selectedRule[fieldName]
          }

          this.ruleDetails.push(obj)
        }
      })
    },

    /**
     * Retrieve user Id from rule details array
     * @param {*} ruleDetails
     * @param {*} key
     */
    getUserIdString(key) {
      let userString = ""
      let userId = ""
      let value = this.selectedRule[key]
      if (value && value !== null) {
        userId = value
        userString = "[ User: " + userId + " ]"
      }
      return userString
    },

    /**
     * parseConditions - Parse conditions from strinified to object
     */
    parseConditions() {
      if (
        this.selectedRule.type !== RULE_TYPE_TRANSFORMATION &&
        this.selectedRule.type !== RULE_TYPE_VALIDATION
      ) {
        return
      }
      this.ruleConditions = []
      let conditions = this.selectedRule.conditions
      if (!this.$lodash.isUndefined(conditions) && conditions.length > 0) {
        let conditionObjects = XVATRulesService.addUniqIds(conditions)
        // Update to add '_fieldName'
        this.retrieveXPathMappings().then(() => {
          this.$lodash.forEach(conditionObjects, condition => {
            let xpathObj = this.$lodash.find(this.xpathMappingsList, {
              xpathLocation: condition.field
            })
            if (!this.$lodash.isUndefined(xpathObj)) {
              condition["_fieldName"] = xpathObj.title
            } else {
              condition["_fieldName"] = "n/a"
            }
          })
          this.ruleConditions = conditionObjects
        })
      }
    },

    /**
     * parseActions - Parse actions from strinified to object
     */
    parseActions() {
      if (this.selectedRule.type !== RULE_TYPE_TRANSFORMATION) {
        return
      }
      this.ruleActions = []
      let actions = this.selectedRule.actions
      if (!this.$lodash.isUndefined(actions) && actions.length > 0) {
        let actionObjects = XVATRulesService.addUniqIds(actions)
        // Update to add '_fieldName'
        this.retrieveXPathMappings().then(() => {
          this.$lodash.forEach(actionObjects, action => {
            let xpathObj = this.$lodash.find(this.xpathMappingsList, {
              xpathLocation: action.field
            })
            if (!this.$lodash.isUndefined(xpathObj)) {
              action["_fieldName"] = xpathObj.title
            } else {
              action["_fieldName"] = "n/a"
            }
          })
          this.ruleActions = actionObjects
          this.resetActionSequenceNumbers()
        })
      }
      // Enables drag and drop on actions
      this.enableActionsDragDrop()
    },

    /**
     * updateActionsSequence-Update RuleActions Sequence
     */
    updateActionsSequence() {
      this.updateActionsInProgress = true
      let ruleObjToUpdate = this.$lodash.cloneDeep(this.selectedRuleOriginal)
      ruleObjToUpdate.actions = this.ruleActions
      ruleObjToUpdate = this.$lodash.omit(ruleObjToUpdate, [
        "_added",
        "_enabled",
        "_updated"
      ])
      this.updateRule(ruleObjToUpdate)
    },

    /**
     * constructJSONViewObject
     */
    constructJSONViewObject() {
      let jsonViewObj = this.$lodash.cloneDeep(this.selectedRuleOriginal)
      jsonViewObj = this.$lodash.omit(jsonViewObj, [
        "_added",
        "_enabled",
        "_updated"
      ])
      // Ensure we are not displaying encoded string in JSON view
      jsonViewObj["description"] = decodeURI(jsonViewObj["description"])
      this.selectedRuleJSON = jsonViewObj
    },

    /**
     * saveTitle - Save changes made to title
     * @param {string} value
     */
    saveField(value, fieldName) {
      this.$validator.validateAll().then(result => {
        if (result) {
          let ruleObjToUpdate = this.$lodash.cloneDeep(
            this.selectedRuleOriginal
          )
          let valueChanged = false
          if (fieldName === "enabled") {
            ruleObjToUpdate.disabled = !value
            valueChanged = !(
              ruleObjToUpdate.disabled === this.selectedRuleOriginal.disabled
            )
          } else {
            value = this.$lodash.isNull(value) ? "" : value
            ruleObjToUpdate[fieldName] = value
            valueChanged = !(
              ruleObjToUpdate[fieldName] ===
              this.selectedRuleOriginal[fieldName]
            )
          }
          // Update only when the value has changed
          if (valueChanged) {
            ruleObjToUpdate = XVATRulesService.omitClientOnlyFields(ruleObjToUpdate)
            this.updateRule(ruleObjToUpdate)
          }
        } else {
          // Clicking on 'clearable' icon sets the value to null
          let fieldObjIndex = this.$lodash.findIndex(this.ruleDetails, {
            name: fieldName
          })
          // Revert to original value
          let originalObj = {
            name: fieldName,
            value: this.selectedRuleOriginal[fieldName]
          }
          // NOTE: This might seem tricky but, this code is trying to addresss the reactivity issues related to vue
          // when dealing with arrays. We are assigning a new array instead of modifying the array
          let ruleDetailsCopy = this.$lodash.cloneDeep(this.ruleDetails)
          this.ruleDetails = [] // to help with reactivity issue
          ruleDetailsCopy.splice(fieldObjIndex, 1, originalObj)
          this.$nextTick(() => {
            this.ruleDetails = ruleDetailsCopy
          })
        }
      })
    },

    /**
     * Cancels inline editing and resets the validation
     */
    cancelInlineEdit() {
      this.$validator.reset()
    },

    /**
     * updateRule - update the rule
     * @param {object} ruleObj
     */
    updateRule(ruleObj) {
      // Encode Description
      ruleObj.description = encodeURI(decodeURI(ruleObj.description))

      xvatDataService
        .updateRule(ruleObj.id, ruleObj)
        .then(() => {
          this.resetData()
          // Show snack bar
          this.snackbar.show = true
          this.snackbar.color = "success"
          this.snackbar.message = this.messages.info.RULE_UPDATED
          XVATRulesService.$emit("event:refreshRulesList")
        })
        .catch(error => {
          let response = error.response.data
          if (response.isException) {
            this.errorAlert = true
            this.errorMessage = response.description
            // Re-populate original data
            this.constructRuleDetails()
            this.parseConditions()
            this.parseActions()
          }
        })
        .finally(() => {
          if (this.updateActionsInProgress) {
            this.updateActionsInProgress = false
          }
        })
    },

    /**
     * hide - Hide the quick view
     */
    hide() {
      if (this.inDialog) {
        XVATRulesService.$emit("event:hideRuleQuickViewDialog")
      } else {
        XVATRulesService.$emit("event:hideRuleQuickView")
      }
      this.resetData()
      this.isVisible = false
    },

    /**
     * goToEditView - Navigate to Edit view
     */
    goToEditView() {
      let id = this.selectedRule.id
      this.$router.push({
        name: "XVATManageRule",
        params: { id: id }
      })
    },

    /**
     * showDeleteDialog -
     */
    showDeleteDialog() {
      this.deleteDialog = true
    },

    /**
     * cancelDelete - close delete dialog
     */
    cancelDelete() {
      this.deleteErrorAlert = false
      this.deleteErrorMessage = ""
      this.deleteDialog = false
    },

    /**
     * deleteRule - Delete selected rule / ruleset / rule collection
     */
    deleteRule() {
      this.deletingRule = true
      let ruleId = this.selectedRule.id
      xvatDataService
        .deleteRule(ruleId)
        .then(() => {
          this.deleteDialog = false
          // Show Snackbar
          this.snackbar.show = true
          this.snackbar.color = "success"
          this.snackbar.message =
            this.messages.info.DELETE_SUCCESS + this.selectedRule.title
          XVATRulesService.$emit("event:refreshRulesList")
        })
        .catch(error => {
          let response = error.response.data
          if (response.isException) {
            this.deleteErrorAlert = true
            if (response.responseCode === 412) {
              this.deleteErrorMessage = XVATRulesService.constructDeleteFailMsg("Rule", this.selectedRule.title)
            } else {
              this.deleteErrorMessage = response.description
            }
          }
        })
        .finally(() => {
          this.deletingRule = false
        })
    },

    /**
     * showTestRuleModal
     */
    showTestRuleModal() {
      this.ruleObjectToTest = this.selectedRule
      this.ruleTestDialog = true
    },

    /**
     * showCopyRuleModal
     */
    showCopyRuleModal() {
      this.ruleObjectToCopy = this.selectedRule
      this.ruleCopyDialog = true
    },

    /**
     * showOverrideRuleModal
     */
    showOverrideRuleModal() {
      this.ruleObjectToOverride = this.selectedRule
      this.ruleOverrideDialog = true
    }
  },
  filters: {
    displayNA(value) {
      if (value === null || value === "") {
        return "n/a"
      } else {
        return value
      }
    }
  },
  created() {
    /**
     * Non reactive properties
     */
    this.messages = messages
    /**
     * Events
     */
    XVATRulesService.$on("event:showRuleQuickView", this.show)
    XVATRulesService.$on("event:showRuleQuickViewDialog", this.showInDialog)
  },
  beforeDestroy() {
    XVATRulesService.$off("event:showRuleQuickView", this.show)
    XVATRulesService.$off(
      "event:showRuleQuickViewDialog",
      this.showInDialog
    )
  }
}
</script>

<style lang="scss" scoped>
.rule-quick-view {
  min-height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}

.handle {
  cursor: move !important;
  cursor: -webkit-grabbing !important;
}

.vop--ace-editor-container {
  position: relative;
}

.vop--ace-editor {
  position: absolute;
  top: 0px;
  bottom: 0px;
  left: 0px;
  right: 0px;
}

.vop--ace-editor .ace_search_field,
.ace_searchbtn:last-child {
  color: black !important;
}
</style>



// WEBPACK FOOTER //
// src/XVAT/Rule/RuleQuickView.vue